export default __webpack_public_path__ + "static/64ebc744b4c0b32a336c0e9a55174806.jpg";